import { SvgSunGlow } from 'app/icons/designSystemIcons/SvgSunGlow';
import { Product } from 'app/types/product';
import { Container, Flex } from 'designSystem/Layouts/Layouts';
import { Title } from 'designSystem/Texts/Texts';

import ProductInfo from './ProductInfo';

export default function AestheticProductHeaderSSR({
  product,
  isMobile,
  isDashboard = false,
  disableCTA = false,
  hidePrice = false,
  disableClientData = true,
}: {
  product: Product;
  isMobile: boolean;
  isDashboard?: boolean;
  disableCTA?: boolean;
  hidePrice?: boolean;
  disableClientData?: boolean;
}) {
  const orderedHighlights =
    product.highlights?.sort((a, b) => a.order - b.order) || [];

  return (
    <div className="md:pt-4 md:pb-12">
      <Container>
        <Title
          as="h1"
          size="2xl"
          className="text-left font-bold mb-8"
          id="pdpTitle"
        >
          {product.title}
        </Title>
      </Container>
      <Container
        className={`px-0 md:px-4 ${!isMobile && 'md:grid md:grid-cols-[3fr,2fr]'} gap-x-12`}
      >
        <div>
          <Flex layout="col-left" className="w-full gap-4 px-4 md:px-0">
            <Flex
              layout="col-left"
              className="gap-4 bg-hg-cream p-4 md:p-6 rounded-2xl md:rounded-t-2xl md:rounded-b-none w-full"
            >
              <Title size="xl" className="font-light">
                Lo que debes saber
              </Title>
              <ul className="flex flex-col">
                {orderedHighlights?.map((item, index, array) => (
                  <li
                    className={`flex gap-4 items-start py-3 ${index + 1 < array.length ? 'border-b border-white/50' : ''}`}
                    key={item}
                  >
                    <SvgSunGlow className="h-6 w-6 text-hg-secondary md:mt-1 shrink-0" />
                    {item.description}
                  </li>
                ))}
              </ul>
            </Flex>
            {isMobile && product?.videos[0]?.url && (
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${product.videos[0].url}`}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="rounded-3xl overflow-hidden mb-4 aspect-[2/3]"
              />
            )}
          </Flex>
          <div className="md:bg-hg-cream md:border-t-4 md:border-hg-cream300 md:rounded-b-2xl w-full">
            <ProductInfo
              product={product}
              className="px-0 mb-0"
              hideAppliedProducts
              hideDuration
              hidePrice={hidePrice}
              disableCTA={disableCTA}
              isDashboard={isDashboard}
              disableClientData={disableClientData}
            />
          </div>
        </div>

        {!isMobile && product?.videos[0]?.url && (
          <Flex layout="col-left" className="w-full">
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${product.videos[0].url}`}
              title={product.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="rounded-3xl overflow-hidden"
            />
          </Flex>
        )}
      </Container>
    </div>
  );
}
